module.exports = __webpack_public_path__ + "static/media/check-circle-regular.bd6957d6.jpg";